export enum ToastType {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Info = 'info',
  ErrorList = 'errorList',
  LinkToast = 'link',
  SiteUpdateAlert = 'siteUpdateAlert',
}
